import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const FilterDropdown = ({ options, placeholder, onSelect, stylings, filters, filtersKey }) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} style={stylings}>
      <DropdownToggle caret outline color="" className="d-flex align-items-center gap-2 rounded" style={{ width: '150px', height: '40px', color:'#000' }}>
        {/* <Filter size={20} /> */}
        {filters[filtersKey] || placeholder}  {/* Show selected filter or placeholder */}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onSelect('')}>Select</DropdownItem>
        {options.map((option, index) => (
          <DropdownItem key={index} onClick={() => onSelect(option)}>
            {option}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default FilterDropdown;

